import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ["search", "sortLabel"]

  connect() {
    this.lastValue = this.searchTarget.value
  }

  disconnect() {
    clearTimeout(this.searchTimeout)
  }

  // Submits 250ms after typing stops. The timeout lives on the instance so disconnect
  // can cancel a pending submit if the page navigates away mid-debounce.
  debouncedSearch() {
    clearTimeout(this.searchTimeout)
    this.searchTimeout = setTimeout(() => {
      if (this.lastValue !== this.searchTarget.value) {
        this.lastValue = this.searchTarget.value
        this.search()
      }
    }, 250)
  }

  search() {
    // Handle folders visibility
    var folders = document.querySelector(".index__folders");
    if (folders) {
      if (this.searchTarget.value) {
        folders.style.display = "none";
      } else {
        folders.style.display = "block";
      }
    }
    // Handle search
    this.searchTarget.form.requestSubmit()
  }

  selectSort(event) {
    const { sortColumn, sortDirection, label } = event.currentTarget.dataset

    if (label && this.hasSortLabelTarget) {
      this.sortLabelTarget.textContent = label
    }

    this.submitSort(event.currentTarget.closest("form"), sortColumn, sortDirection)
  }

  submitSort(form, sortColumn, sortDirection) {
    if (!form) return
    if (!sortColumn || !sortDirection) return

    const sortColumnInput = form.querySelector('[name="sort_column"]')
    const sortDirectionInput = form.querySelector('[name="sort_direction"]')

    if (sortColumnInput) sortColumnInput.value = sortColumn
    if (sortDirectionInput) sortDirectionInput.value = sortDirection

    form.requestSubmit()
  }

  // Places the caret at the end of the field on focus, such as when the input
  // keeps its value across a Turbo Frame reload, so typing continues from the end.
  moveCursorToEnd() {
    const length = this.searchTarget.value.length
    this.searchTarget.setSelectionRange(length, length)
  }

  preserveSearch(event) {
    const url = new URL(event.currentTarget.href, window.location.origin)
    const query = this.searchTarget.value.trim()

    if (query.length > 0) {
      url.searchParams.set("query", query)
    } else {
      url.searchParams.delete("query")
    }

    event.currentTarget.setAttribute("href", `${url.pathname}${url.search}${url.hash}`)
  }
}
